import { AsYouType } from 'libphonenumber-js'

export const COUNTRY_CODE = 'US'

export function formatPhoneNumber(value: string) {
  if (!value) return value

  const formatter = new AsYouType(COUNTRY_CODE)
  return formatter.input(value)
}
